import {
  Heading,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
  Stack,
} from '@chakra-ui/react';
import NextLink from 'next/link';
import { DEFAULT_NETWORK } from '../../web3/constants';
import { getTransactionUrl } from '../../web3/helpers';

interface IProps {
  modalReqs: {
    txHash?: string;
    isOpen: boolean;
    onClose: () => void;
  };
}

const TransactionWaitModal: React.FC<IProps['modalReqs']> = ({ txHash, isOpen, onClose }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen} scrollBehavior="inside" motionPreset="scale" size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody textAlign="center" py={8}>
          <Stack spacing="4" align="center">
            <Heading fontSize="xl">Waiting for transaction</Heading>

            <Spinner thickness="4px" speed="0.56s" emptyColor="teal.100" size="xl" color="teal" />

            {txHash && (
              <NextLink href={`${getTransactionUrl(DEFAULT_NETWORK, txHash)}`} passHref>
                <Link isExternal color="brand.teal" textDecoration="underline">
                  Watch the transaction on Etherscan
                </Link>
              </NextLink>
            )}
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TransactionWaitModal;
